// extracted by mini-css-extract-plugin
export var deleteIcon = "_tj-5";
export var deleteOption = "_tj-3";
export var divider = "_tj-2";
export var downloadIcon = "_tj-4";
export var drawer = "_tj-0";
export var drawerFooter = "_tj-6";
export var drawerOpen = "_tj-1";
export var highlighted = "_tj-7";
export var lighterHighlight = "_tj-8";